import { Injectable } from '@angular/core';
import { THEMES } from '@models/themes';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private _currentTheme = new BehaviorSubject<THEMES>(THEMES.DEFAULT);
  theme$: Observable<string> = this._currentTheme.asObservable();

  setTheme(theme: THEMES): void {
    this._currentTheme.next(theme);
  }

  static getThemeFromBusinessUnit(bu?: string): THEMES {
    switch (bu) {
      case 'fr':
        return THEMES.FR;
      case 'fimm':
        return THEMES.FIMM;
      case 'casando':
        return THEMES.CASANDO;
      case 'dhome':
        return THEMES.DHOME;

      default:
        return THEMES.DEFAULT;
    }
  }
}
